import * as api from "../api/userAPI";
import * as types from "../constants/userConstants";

// Create follow request
export const createFollowRequestAction = (userId) => async (dispatch) => {
  try {
    const { error, data } = await api.createFollowRequest(userId);
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.CREATE_FOLLOW_REQUEST_SUCCESS,
      payload: { request: data.request || data },
    });
    return { success: true, data };
  } catch (error) {
    dispatch({
      type: types.CREATE_FOLLOW_REQUEST_FAIL,
      payload: error.message,
    });
    return { success: false, error: error.message };
  }
};

// Get received follow requests
export const getReceivedFollowRequestsAction = (status, limit = 25, skip = 0) => async (dispatch) => {
  try {
    const { error, data } = await api.getReceivedFollowRequests(status, limit, skip);
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.GET_RECEIVED_FOLLOW_REQUESTS_SUCCESS,
      payload: {
        requests: data.requests || [],
        total: data.total || 0,
      },
    });
    return { success: true, data };
  } catch (error) {
    dispatch({
      type: types.GET_RECEIVED_FOLLOW_REQUESTS_FAIL,
      payload: error.message,
    });
    return { success: false, error: error.message };
  }
};

// Clear received follow requests
export const clearReceivedFollowRequestsAction = () => ({
  type: types.CLEAR_RECEIVED_FOLLOW_REQUESTS,
});

// Get sent follow requests
export const getSentFollowRequestsAction = (status, limit = 25, skip = 0) => async (dispatch) => {
  try {
    const { error, data } = await api.getSentFollowRequests(status, limit, skip);
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.GET_SENT_FOLLOW_REQUESTS_SUCCESS,
      payload: {
        requests: data.requests || [],
        total: data.total || 0,
      },
      skip, // Pass skip to reducer for pagination logic
    });
    return { success: true, data };
  } catch (error) {
    dispatch({
      type: types.GET_SENT_FOLLOW_REQUESTS_FAIL,
      payload: error.message,
    });
    return { success: false, error: error.message };
  }
};

// Clear sent follow requests
export const clearSentFollowRequestsAction = () => ({
  type: types.CLEAR_SENT_FOLLOW_REQUESTS,
});

// Accept follow request
export const acceptFollowRequestAction = (requestId) => async (dispatch) => {
  try {
    const { error, data } = await api.acceptFollowRequest(requestId);
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.ACCEPT_FOLLOW_REQUEST_SUCCESS,
      payload: { request: data.request || data },
    });
    return { success: true, data };
  } catch (error) {
    dispatch({
      type: types.ACCEPT_FOLLOW_REQUEST_FAIL,
      payload: error.message,
    });
    return { success: false, error: error.message };
  }
};

// Deny follow request
export const denyFollowRequestAction = (requestId) => async (dispatch) => {
  try {
    const { error, data } = await api.denyFollowRequest(requestId);
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.DENY_FOLLOW_REQUEST_SUCCESS,
      payload: { request: data.request || data },
    });
    return { success: true, data };
  } catch (error) {
    dispatch({
      type: types.DENY_FOLLOW_REQUEST_FAIL,
      payload: error.message,
    });
    return { success: false, error: error.message };
  }
};

// Withdraw follow request (for requester to cancel their own pending request)
export const withdrawFollowRequestAction = (requestId) => async (dispatch) => {
  try {
    const { error, data } = await api.withdrawFollowRequest(requestId);
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.WITHDRAW_FOLLOW_REQUEST_SUCCESS,
      payload: { requestId },
    });
    return { success: true, data };
  } catch (error) {
    dispatch({
      type: types.WITHDRAW_FOLLOW_REQUEST_FAIL,
      payload: error.message,
    });
    return { success: false, error: error.message };
  }
};
